
























import { Component, Vue } from 'vue-property-decorator'
import { scrollToElement } from '@/service/animations'
import { isMediumScreen } from '@/service/utils'

import BaseLink from '@/components/common/BaseLink.vue'

@Component( {
    components: {
        'oe-link': BaseLink
    }
} )
export default class ApplicationFooter extends Vue {
    showConsent( event: Event ) {
        event.preventDefault()

        this.$store.commit( 'globalModule/showConsent' )
        scrollToElement( '.oe-consent' )
    }
}
